import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { estadisticasAPI } from '../../services/api'

const initialState = {
  // Series de los últimos 8 meses (viejo -> nuevo) para sparklines
  tendencias: {
    meses: [],
    dotacion: [],
    cobertura: [],
    recaudacion: [],
    citaciones: [],
  },
  tendenciasLoading: false,
  error: null,
}

export const fetchTendencias = createAsyncThunk(
  'estadisticas/fetchTendencias',
  async (_, { rejectWithValue }) => {
    try {
      const response = await estadisticasAPI.getTendencias()
      return response.data?.data || {}
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || error?.message || 'No fue posible cargar las tendencias'
      )
    }
  }
)

const estadisticasSlice = createSlice({
  name: 'estadisticas',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTendencias.pending, (state) => {
        state.tendenciasLoading = true
        state.error = null
      })
      .addCase(fetchTendencias.fulfilled, (state, action) => {
        state.tendenciasLoading = false
        state.tendencias = {
          meses: action.payload.meses || [],
          dotacion: action.payload.dotacion || [],
          cobertura: action.payload.cobertura || [],
          recaudacion: action.payload.recaudacion || [],
          citaciones: action.payload.citaciones || [],
        }
      })
      .addCase(fetchTendencias.rejected, (state, action) => {
        state.tendenciasLoading = false
        state.error = action.payload || 'Error al cargar tendencias'
      })
  },
})

export default estadisticasSlice.reducer
